import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useDayFactor } from "../context";
import { COLORS, DAY_COLORS } from "../constants";

export default function DynamicSky() {
  const matRef = useRef();
  const dayRef = useDayFactor();
  const uniforms = useMemo(
    () => ({
      nightTop: { value: new THREE.Color(COLORS.twilightTop) },
      nightMid: { value: new THREE.Color(COLORS.navy) },
      nightHorizon: { value: new THREE.Color(COLORS.twilightHorizon) },
      dayTop: { value: new THREE.Color(DAY_COLORS.skyTop) },
      dayMid: { value: new THREE.Color(DAY_COLORS.skyMid) },
      dayHorizon: { value: new THREE.Color(DAY_COLORS.skyHorizon) },
      factor: { value: 0 },
    }),
    []
  );
  useFrame(() => {
    if (matRef.current) {
      matRef.current.uniforms.factor.value = dayRef.current;
    }
  });
  return (
    <mesh scale={[300, 300, 300]}>
      <sphereGeometry args={[1, 32, 32]} />
      <shaderMaterial
        ref={matRef}
        side={THREE.BackSide}
        uniforms={uniforms}
        vertexShader={`
          varying vec3 vWorld;
          void main(){
            vWorld = (modelMatrix * vec4(position,1.0)).xyz;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }
        `}
        fragmentShader={`
          uniform vec3 nightTop;
          uniform vec3 nightMid;
          uniform vec3 nightHorizon;
          uniform vec3 dayTop;
          uniform vec3 dayMid;
          uniform vec3 dayHorizon;
          uniform float factor;
          varying vec3 vWorld;
          void main(){
            float h = normalize(vWorld).y;
            vec3 top = mix(nightTop, dayTop, factor);
            vec3 mid = mix(nightMid, dayMid, factor);
            vec3 horizon = mix(nightHorizon, dayHorizon, factor);
            vec3 col;
            if(h > 0.0){
              col = mix(mid, top, smoothstep(0.0, 0.7, h));
            } else {
              col = mix(mid, horizon, smoothstep(0.0, -0.2, h));
            }
            gl_FragColor = vec4(col, 1.0);
          }
        `}
      />
    </mesh>
  );
}
